import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from 'src/app/core/services/global.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';

@Injectable()
export class ChatService {
  private socket!: WebSocket;
  private token: string;
  private auth: {
    token: string;
  };

  constructor(private globalService: GlobalService, private http: HttpClient, private mdlzDataService: MondelezDataService) {
    this.mdlzDataService.currentScenarioChanged.subscribe((scenario) => {
      console.log('scenario changed');
      this.closeConnection();
    });
  }

  public initSocket(port: number): void {
    const socketUrl = `ws://localhost:${port}/`; // port is used to get the dynamic port data and render it
    if (!this.socket || this.socket?.readyState === WebSocket.CLOSED) this.socket = new WebSocket(socketUrl);
    console.log('socket connected', port);
    this.socket.addEventListener('open', () => {
      console.log('WebSocket is open now.');
    });

    this.socket.addEventListener('message', (event) => {
      // console.log('Message from server:', event.data);
    });

    this.socket.addEventListener('close', () => {
      console.log('WebSocket is closed now.');
      this.socket = null;
    });

    this.socket.addEventListener('error', (error) => {
      console.error('WebSocket error observed:', error);
    });
  }

  public initServerSocket(url): void {
    if (!this.socket || this.socket?.readyState === WebSocket.CLOSED) {
      this.socket = new WebSocket(url);
      console.log('new socket connection established ', url);
    } else {
      console.log('socket connection already opened', url);
    }
  }

  public sendMessage(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.token = this.globalService.token;
      // console.log('token', this.token);
      this.auth = {
        token: this.token,
      };
      // console.log('auth', this.auth);
      const eventObject = {
        ...this.auth,
        type: 'sendMessage',
        message: message,
      };
      this.socket.send(JSON.stringify(eventObject));
    } else {
      console.error('WebSocket is not open. ReadyState:', this.socket?.readyState);
    }
  }

  public sendFeedback(payload) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.token = this.globalService.token;
      this.auth = {
        token: this.token,
      };
      const eventObject = {
        ...this.auth,
        ...payload,
        type: 'sendMessage',
        message: 'user_liked_disliked',
      };
      this.socket.send(JSON.stringify(eventObject));
    } else {
      console.error('WebSocket is not open. ReadyState:', this.socket?.readyState);
    }
  }

  async getMessage(): Promise<Observable<any>> {
    return new Observable<any>((observer) => {
      this.socket.addEventListener('message', ({ data }) => {
        let event = null;
        event = JSON.parse(data);
        observer.next(event);
        observer.complete();
      });
    });
  }

  getChatHistory(data: any) {
    const url = `${environment.serverUrl}/simulator/get-chat-history`;
    return this.http.post(url, data);
  }

  closeConnection() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.token = this.globalService.token;
      this.auth = {
        token: this.token,
      };
      const eventObject = {
        ...this.auth,
        type: 'sendMessage',
        message: 'disconnect',
      };
      this.socket.send(JSON.stringify(eventObject));
      this.socket?.close();
      console.log('socket disconnected');
    }
  }

  resetSocketOnLogout() {
    this.socket?.close();
    this.socket = null;
    this.token = undefined;
    this.auth = {
      token: undefined,
    };
  }
}
